import { PublicPage } from 'api/website';
import {
  getContentFirstRealBlockIndex,
  getContentOffsetAnchors,
  getContentWithBanner,
  getPrevRealBlock,
} from 'cms/helpers';

import { MappedContentBlock, mapContentBlock } from './mapContentBlock';

type Props = {
  content: PublicPage;
};

export function mapContentBlocksForBody({
  content,
}: Props): MappedContentBlock[] {
  const firstRealBlockIndex = getContentFirstRealBlockIndex({ content });
  const offsetAnchors = getContentOffsetAnchors({ content });
  const withBanner = getContentWithBanner({ content });

  return content.contentBlocks
    .map((block, index) => {
      const prevBlock = getPrevRealBlock(content.contentBlocks, index);

      return mapContentBlock({
        content,
        blocks: content.contentBlocks,
        index,
        block,
        isSidebar: false,
        isPageHeader: !withBanner && firstRealBlockIndex === index,
        anchor:
          index > 0 && prevBlock && prevBlock.type === 'ANCHOR'
            ? prevBlock
            : undefined,
        offsetAnchors,
      });
    })
    .filter((mappedContentBlock) => mappedContentBlock.type !== 'ANCHOR');
}
